import { useQuery } from "@tanstack/react-query";
import {
  getManagedSecret,
  listManagedSecrets,
  listManagedSecretVersions,
} from "./api";

const managedSecretStaleTimeMs = 30 * 1000;

export const managedSecretKeys = {
  all: ["devplane", "managed-secrets"] as const,
  lists: () => [...managedSecretKeys.all, "list"] as const,
  list: (organizationId: string) =>
    [...managedSecretKeys.lists(), organizationId] as const,
  details: () => [...managedSecretKeys.all, "detail"] as const,
  detail: (secretId: string) =>
    [...managedSecretKeys.details(), secretId] as const,
  versions: (secretId: string) =>
    [...managedSecretKeys.detail(secretId), "versions"] as const,
};

export function useManagedSecretsQuery(
  organizationId: string,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: managedSecretKeys.list(organizationId),
    queryFn: () => listManagedSecrets(organizationId),
    enabled: enabled && Boolean(organizationId),
    staleTime: managedSecretStaleTimeMs,
  });
}

export function useManagedSecretQuery(
  secretId: string,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: managedSecretKeys.detail(secretId),
    queryFn: () => getManagedSecret(secretId),
    enabled: enabled && Boolean(secretId),
    staleTime: managedSecretStaleTimeMs,
  });
}

export function useManagedSecretVersionsQuery(
  secretId: string,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: managedSecretKeys.versions(secretId),
    queryFn: () => listManagedSecretVersions(secretId),
    enabled: enabled && Boolean(secretId),
    staleTime: managedSecretStaleTimeMs,
  });
}
